function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Einde-contract",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar-disable",
  transform: "translate(3.000000, 3.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#485156",
  x: 0.223684211,
  y: 4.69736842,
  width: 33.5526316,
  height: 29.0789474,
  rx: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.223684211,
  y1: 13.6447368,
  x2: 33.7763158,
  y2: 13.6447368,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.17105263,
  y1: 8.05263158,
  x2: 9.17105263,
  y2: 0.223684211,
  id: "Path",
  stroke: "#485156",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.8289474,
  y1: 8.05263158,
  x2: 24.8289474,
  y2: 0.223684211,
  id: "Path",
  stroke: "#485156",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.5263158,
  y1: 19.2368421,
  x2: 21.4736842,
  y2: 28.1842105,
  id: "Path",
  stroke: "#425CD4",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.5263158,
  y1: 28.1842105,
  x2: 21.4736842,
  y2: 19.2368421,
  id: "Path",
  stroke: "#425CD4",
  strokeLinecap: "round"
})));
function SvgEindecontract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Einde contract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEindecontract);
export default __webpack_public_path__ + "static/media/Einde contract.b4c4e5d3d8dff78d8e37cdc8c106bdf1.svg";
export { ForwardRef as ReactComponent };